import { useEffect, useState } from "react";

import clsx from "clsx";

import { OrderTagFilters } from "@pages/settings/order-tag-filters/shared/order-tag-filters";
import { useOrderTagExclusions } from "@pages/settings/order-tag-filters/use-order-tag-exclusions";
import Spinner from "@shared/spinner";

import { InfoPanel, ReadDocumentationButton } from "../components/info-panel";
import { Table } from "../components/table";

export const OrderTagExclusions = ({
  disabled = false,
}: {
  disabled?: boolean;
}) => {
  const {
    isSynced,
    loading,
    tagBasedOrderExclusions,
    updateTagOrderExclusionByIndex,
    createTagOrderExclusions,
    removeTagBasedOrderExclusion,
  } = useOrderTagExclusions();

  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowTable(tagBasedOrderExclusions.length > 0);
    }
  }, [loading, tagBasedOrderExclusions]);

  return (
    <>
      <Table className="w-full" tableLayout="auto">
        <thead>
          <tr>
            <th className="col-span-2">Common Order Exclusion Tags</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-t odd:bg-cosmic-5 even:bg-white">
            <td className="border-r">
              Returns (used to exclude from Attribution)
            </td>
            <td>Marketplace or app orders (e.g. Tapcart, Shop App)</td>
          </tr>
          <tr className="border-t odd:bg-cosmic-5 even:bg-white">
            <td className="border-r">
              Cancelled orders (used to exclude from Attribution)
            </td>
            <td>
              Third party checkout orders (e.g. ClickFunnels, Walmart, etc.)
            </td>
          </tr>
        </tbody>
      </Table>
      {showTable ? (
        <OrderTagFilters
          title=""
          isSynced={isSynced}
          loading={loading}
          tagFilters={tagBasedOrderExclusions}
          updateTagFilters={updateTagOrderExclusionByIndex}
          createTagFilters={createTagOrderExclusions}
          removeTagFilters={removeTagBasedOrderExclusion}
        />
      ) : (
        <div className="w-full h-[120px] bg-white rounded-lg border border-gray-1 justify-center items-center inline-flex">
          {loading ? (
            <Spinner />
          ) : (
            <button
              className={clsx(
                "px-4 py-3.5 rounded-3xl justify-center items-center gap-2 flex text-cosmic",
                !disabled && "hover:bg-cosmic-5",
              )}
              onClick={() => {
                createTagOrderExclusions();
                setShowTable(true);
              }}
              disabled={disabled}
            >
              {disabled ? (
                <span className="font-semibold uppercase leading-tight tracking-tight">
                  No order exclusions configured
                </span>
              ) : (
                <>
                  <i className="fa-regular fa-sharp fa-circle-plus" />
                  <span className="font-semibold uppercase leading-tight tracking-tight">
                    Add an Order exclusion
                  </span>
                </>
              )}
            </button>
          )}
        </div>
      )}
    </>
  );
};

export const OrderTagExclusionDocPanel = ({
  className,
}: {
  className?: string;
}) => (
  <InfoPanel className={className} label="Need help with Order Exclusions?">
    <ReadDocumentationButton docUrl="https://docs.northbeam.io/docs/orders-api#order-exclusions" />
  </InfoPanel>
);
